'use strict';
module.exports = function (obj) {
	var keys = Object.keys(obj);
	var ret = [];

	for (var i = 0; i < keys.length; i++) {
		ret.push(obj[keys[i]]);
	}

	return ret;
};



//////////////////
// WEBPACK FOOTER
// ./~/object-values/index.js
// module id = 26
// module chunks = 0